/**
 * App location city aliases are raw app/IP/reverse-geocode city names mapped to
 * ACKO Drive sellable city slugs. Keys must match the normalized output from
 * `resolveSellableCity`.
 */
export const APP_LOCATION_CITY_MAPPING: Record<string, string> = {
  "adugodi": "bangalore",
  "balasore": "bangalore",
  "baneglore": "bangalore",
  "bangalore": "bangalore",
  "bangalore-560065": "bangalore",
  "banglore": "bangalore",
  "bangloore": "bangalore",
  "bengaluru": "bangalore",
  "bengaluru-4779": "bangalore",
  "bnaglore": "bangalore",
  "hoskote": "bangalore",
  "hosur": "bangalore",
  "itpl-whitefield": "bangalore",
  "kanakapura": "bangalore",
  "kolar": "bangalore",
  "ramanagar": "bangalore",
  "tumkur": "bangalore",
  "560065": "bangalore",

  "del": "delhi",
  "delhi": "delhi",
  "delhi-110051": "delhi",
  "delhi-110094": "delhi",
  "delhi-6748": "delhi",
  "delhi-cantonment": "delhi",
  "delhi-ncr": "delhi",
  "dhaula-kuan": "delhi",
  "dharuhera": "delhi",
  "dwarka": "delhi",
  "ghaziabad": "delhi",
  "gurgaon-122001": "delhi",
  "khanpur-new-delhi": "delhi",
  "lajpat-nagar": "delhi",
  "mahipalpur": "delhi",
  "new-delhi": "delhi",
  "new-delhidelhi": "delhi",
  "new-friends-colony": "delhi",
  "noida": "delhi",
  "pithampur": "delhi",
  "rijokri": "delhi",
  "rohini": "delhi",
  "sahibabad": "delhi",
  "south-delhi": "delhi",
  "south-west-delhi": "delhi",
  "west-delhi": "delhi",

  "faridabad": "faridabad",
  "palwal": "faridabad",

  "gaziabad": "ghaziabad",
  "ghaziabaad": "ghaziabad",
  "ghazibad": "ghaziabad",
  "modinagar": "ghaziabad",
  "muradnagar": "ghaziabad",

  "gurgaon": "gurgaon",
  "gurgoan": "gurgaon",
  "gurugram": "gurgaon",
  "manesar": "gurgaon",
  "panipat": "gurgaon",
  "rewari": "gurgaon",
  "sohna": "gurgaon",
  "sonipat": "gurgaon",

  "hyd": "hyderabad",
  "hydrabad": "hyderabad",
  "hyderabad": "hyderabad",
  "hyderabad-500072": "hyderabad",
  "hyderabad-telangana-india": "hyderabad",
  "ibrahimpatnam": "hyderabad",
  "madhapar": "hyderabad",
  "nanakramguda": "hyderabad",
  "quthbullapur": "hyderabad",
  "sangareddi": "hyderabad",
  "secunderabad": "hyderabad",
  "serilingampalle": "hyderabad",
  "shadnagar": "hyderabad",
  "vikarabad": "hyderabad",

  "alwar": "jaipur",
  "bandikui": "jaipur",
  "bassi": "jaipur",
  "beawar": "jaipur",
  "chomu": "jaipur",
  "dausa": "jaipur",
  "jaipur": "jaipur",
  "kanota": "jaipur",
  "kishangarh": "jaipur",
  "kotputli": "jaipur",
  "sawai-madhopur": "jaipur",
  "shahpura": "jaipur",
  "tonk": "jaipur",

  "barabanki": "lucknow",
  "faizabad": "lucknow",
  "hardoi": "lucknow",
  "kanpur": "lucknow",
  "khalilabad": "lucknow",
  "lucknow": "lucknow",
  "raebareli": "lucknow",
  "sitapur": "lucknow",
  "unnao": "lucknow",

  "airoli": "mumbai",
  "andheri": "mumbai",
  "bhandup": "mumbai",
  "bhayandar": "mumbai",
  "bhiwandi": "mumbai",
  "borivali": "mumbai",
  "dombivali": "mumbai",
  "dombivli": "mumbai",
  "greater-mumbai": "mumbai",
  "igatpuri": "mumbai",
  "kalyan": "mumbai",
  "khar-west": "mumbai",
  "kharghar": "mumbai",
  "lonavla": "mumbai",
  "mira-road": "mumbai",
  "mulund-east": "mumbai",
  "mumbai": "mumbai",
  "mumbai-400708": "mumbai",
  "mumbai-suburban": "mumbai",
  "mumbai-thane": "mumbai",
  "navi-mumbai": "mumbai",
  "panvel": "mumbai",
  "powai": "mumbai",
  "santa-cruz": "mumbai",
  "shahapur": "mumbai",
  "sion": "mumbai",
  "thana": "mumbai",
  "thane": "mumbai",
  "ulhasnagar": "mumbai",
  "vasai": "mumbai",
  "virar": "mumbai",

  "charkhi-dadri": "noida",
  "dadri": "noida",
  "gautam-buddha-nagar": "noida",
  "gautam-budh-nagar": "noida",
  "greater-noida": "noida",
  "noida-126": "noida",
  "noida-8398": "noida",
  "west-delhi-noida-office": "noida",

  "alandi": "pune",
  "bhor": "pune",
  "chakan": "pune",
  "chikhli": "pune",
  "dehu-road": "pune",
  "haveli": "pune",
  "hinjawadi": "pune",
  "khadki": "pune",
  "kharadi": "pune",
  "lohogaon": "pune",
  "narayangaon": "pune",
  "pimpri": "pune",
  "pimpri-chinchwad": "pune",
  "pirangut": "pune",
  "pune": "pune",
  "pune-412101": "pune",
  "pune-6609": "pune",
  "pune-sp-infocity-fursungi": "pune",
  "shirur": "pune",
  "yerwada": "pune",
};
